module.exports = __webpack_public_path__ + "static/img/zhiyuan.ff788a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/zhiyuan.png
// module id = Ylgf
// module chunks = 1